<template lang="pug">
  header
    //- (full bleed, E1): the header image runs edge to edge under the top bar, the title sits below it.
    //- "Original ratio" uses the same placement but shows the whole photograph, uncropped.
    //- On a portrait phone Full bleed also shows the whole photograph, edge to edge at its own
    //- height, instead of a 4:5 crop (Guido, 8 Oct 2026: Wellington Dam header cut to phone width).
    template(v-if="isBleed")
      .pt-72.md-pt-144
        .w-full.clearfix
          imageset(:items="slice0.items", :aspectRatio="showWhole ? '3x2' : '16x9'", :view="showWhole ? null : 'full-bleed'", :original="showWhole", :flush="true", :inset="true")
        .px-24.pt-8.pb-24.md-pt-24.md-pb-48.flex.items-center.justify-center
          .type-title.text-center
            prismic-rich-text.italic.font-medium(:field="doc.title")
            h4(v-html="subtitle(doc.location, doc.mural_completion_date)")

    //- (text | image)
    template(v-else-if="layout.includes('text | images')")
      .pt-72.md-pt-144.px-12.lg-px-prjbody.md-flex.flex-wrap
        .min-h-112.md-min-h-0.md-w-1x2.px-12.md-border-r.flex.items-center.justify-center
          .type-title.text-center
            prismic-rich-text.italic.font-medium(:field="doc.title")
            h4(v-html="subtitle(doc.location, doc.mural_completion_date)")
        .md-w-1x2.px-12.clearfix
          imageset(:items="slice0.items", aspectRatio="4x5", :flush="true")
      //- bottom border
      .hidden.md-block.px-24.w-full
        .pb-12.border-b

    //- (default)
    template(v-else)
      .pt-72.-mb-24.px-12
        .min-h-0.md-min-h-300.flex.items-center.justify-center
          //- less space above the image on phones (F3)
          .type-title.text-center.py-24.md-py-112
            prismic-rich-text.italic.font-medium(:field="doc.title")
            h4(v-html="subtitle(doc.location, doc.mural_completion_date)")
        .px-12.clearfix.lg-px-prjbody
          imageset(:items="slice0.items", aspectRatio="3x2")
</template>

<script>
import Vue from 'vue'
import Imageset from '@/components/Project/Imageset'
import _get from 'lodash/get'
import { prjYear } from '@/utils'
export default {
  name: 'ProjectHeader',
  props: ['doc'],
  data () {
    return {
      prjYear
    }
  },
  computed: {
    slice0 () {
      return _get(this.doc, 'header[0]') || { items: [] }
    },
    layout () {
      return this.doc.header_layout || ''
    },
    // Prismic "Header display" select: Default / Full bleed / Original ratio
    // "Original ratio" shows the whole photograph at its own shape, still edge to edge
    isOriginal () {
      return /original/i.test(this.doc.header_display || '')
    },
    isBleed () {
      return this.isOriginal || /full/i.test(this.doc.header_display || '')
    },
    isPhonePortrait () {
      return this.$store.getters.isPortrait && this.$store.state.winW < Vue.config.bkpts.md
    },
    // the whole photograph, uncropped: always for "Original ratio", and for Full bleed on a portrait
    // phone (the 4:5 crop cut 40% off the Wellington Dam header). Desktop keeps the 16:9 full bleed.
    showWhole () {
      return this.isOriginal || this.isPhonePortrait
    }
  },
  methods: {
    subtitle (location, date) {
      const year = date && date.split('-')[0]
      let sub = this.$prismic.richTextAsPlain(location)
      sub += year ? ', <br class="md-hidden">' + year : ''
      return sub
    }
  },
  components: { Imageset }
}
</script>

<style>
</style>
